import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { WHITE_LABEL_ACCENT_COLOR } from '../../../lib/white-label';
import Eye from '../../svgs/Eye';

const TidalInputFieldWrapper = styled.div`
  width: 100%;

  & > .label {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 8px;
    position: relative;
    width: fit-content;
    color: ${(props) => props.theme.colors.text[0]};
    & > span {
      position: absolute;
      right: -10px;
      bottom: 4px;
      color: ${(props) => props.theme.colors.text[3]};
    }
  }
  & > div > input {
    height: 100%;
    width: 100%;
    background-color: ${(props) => props.theme.colors.secondary};
    padding: 0 16px;
    border-radius: 10px;
    &:focus {
      outline: 2px solid ${(props) => WHITE_LABEL_ACCENT_COLOR};
    }
  }
  & > div {
    border-radius: 10px;
    height: 42px;
    border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
    background-color: ${(props) => props.theme.colors.secondary};
    position: relative;
  }
  & > div > .input-eye {
    position: absolute;
    display: flex;
    align-items: center;
    height: 100%;
    width: 20px;
    top: 0;
    right: 8px;
  }
  & > div > input[type='file'] {
    padding: 5px 16px;
  }
  & > div > input[type='submit']:hover {
    outline: 2px solid ${(props) => WHITE_LABEL_ACCENT_COLOR};
    cursor: pointer;
  }
`;

interface ITidalInputField {
  label?: string;
  placeholder: string;
  isRequired?: boolean;
  type?: string;
  id?: string;
  name?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  multiple?: boolean;
  className?: string;
  onBlur?: (e: any) => void;
  onChange?: (e: any) => void;
}

const TidalInputField = ({
  label,
  placeholder,
  isRequired,
  type,
  name,
  id,
  value,
  defaultValue,
  disabled,
  multiple,
  className,
  onChange,
  onBlur,
}: ITidalInputField): JSX.Element => {
  const [isVisible, setIsVisible] = useState(type == 'password' ? false : true);
  const [valueState, setValueState] = useState(defaultValue);

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <TidalInputFieldWrapper className={className || undefined}>
      {label.length > 0 && (
        <p className="label pt-1">
          {label}
          {isRequired && <span>*</span>}
        </p>
      )}
      <div>
        <input
          id={id}
          name={name}
          disabled={disabled}
          onBlur={onBlur}
          style={{
            color: disabled ? 'rgb(151, 151, 151)' : '#000',
          }}
          onChange={(e) => onChange && onChange(e)}
          type={type == 'password' ? (isVisible ? 'text' : 'password') : type}
          value={valueState}
          placeholder={placeholder}
          multiple={multiple}
        />
        {type == 'password' && (
          <button
            className="input-eye"
            onClick={() => setIsVisible((isVisible) => !isVisible)}
          >
            <Eye />
          </button>
        )}
      </div>
    </TidalInputFieldWrapper>
  );
};

TidalInputField.defaultProps = {
  disabled: false,
};

export default TidalInputField;
